import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BannerModule, BreadcrumbsModule, AlertsModule, UiGuideModule } from '@dor-mvtrip/shared-angular-components';
import { NgxsModule } from '@ngxs/store';
import { AppState } from './core/state/app.state';
import { AppConfigService } from './app-config.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CookieService } from 'ngx-cookie-service';
import { ErrorInterceptorService } from './core/services/error-interceptor.service';
import { ReactiveFormsModule } from '@angular/forms';
import { GlobalComponentsModule } from './core/components/global-components.module';

const configFactory = (configService: AppConfigService) => {
	return () => configService.loadConfig();
};

@NgModule({
	declarations: [ AppComponent ],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		NgxsModule.forRoot([ AppState ]),
		//GlobalComponentsModule,
		AppRoutingModule,
		AlertsModule,
		BannerModule,
		BreadcrumbsModule,
		HttpClientModule,
		ReactiveFormsModule,
		ModalModule.forRoot(),
		TooltipModule.forRoot(),
		GlobalComponentsModule,
		UiGuideModule
	],
	providers: [
		{
			provide: APP_INITIALIZER,
			useFactory: configFactory,
			deps: [ AppConfigService ],
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ErrorInterceptorService,
			multi: true
		},
		CookieService
	],
	bootstrap: [ AppComponent ]
})
export class AppModule {}
